import React from "react";
import { Theme } from "interfaces/theme";
import * as S from "./styles";

interface IGallery {
  mode: Theme;
}
const Gallery: React.FC<IGallery> = ({ mode }) => {
  return (
    <S.Container mode={mode}>
      <S.Content>
        <S.Item>
          <S.FigureWrapper>
            <S.Figure>
              <S.Photo1Dark className="dark" />
              <S.Photo1Light />
            </S.Figure>
          </S.FigureWrapper>
          <S.LegendLight>
            Vestido, Gucci. Gravata, Louis Vuitton. Brincos, Swarovski.
          </S.LegendLight>
          <S.LegendDark>Colar, Giorgio Armani.</S.LegendDark>
        </S.Item>
        <S.Item>
          <S.FigureWrapper>
            <S.Figure>
              <S.Photo2Dark className="dark" />
              <S.Photo2Light />
            </S.Figure>
          </S.FigureWrapper>
          <S.LegendLight>
            Macacão, jaqueta, colar e brincos, tudo Chanel.
          </S.LegendLight>
          <S.LegendDark>Jaqueta, Louis Vuitton</S.LegendDark>
        </S.Item>
      </S.Content>
      <S.Content className="last">
        <S.Item>
          <S.FigureWrapper>
            <S.Figure>
              <S.Photo3Dark className="dark" />
              <S.Photo3Light />
            </S.Figure>
          </S.FigureWrapper>
          <S.LegendLight>
            Corset, Madame Sher. Colar e brincos, Swarovski.
          </S.LegendLight>
          <S.LegendDark>
            Top, Vitor Zerbinato. Boá, Israel Valentim. Colar, Tiffany & Co.
          </S.LegendDark>
        </S.Item>
        <S.Item>
          <S.FigureWrapper>
            <S.Figure>
              <S.Photo4Dark className="dark" />
              <S.Photo4Light />
            </S.Figure>
          </S.FigureWrapper>
          <S.LegendLight>
            Top, David Koma na CJ Mares. Brincos, Bottega Online.
          </S.LegendLight>
          <S.LegendDark>
            Top, Vitor Zerbinato. Luvas, Louis Vuitton. Brincos, Chanel.
          </S.LegendDark>
        </S.Item>
      </S.Content>
    </S.Container>
  );
};

export default Gallery;
